<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card
      [title]="'guarantor.title' | translate"
      [subtitle]="'guarantor.subtitle' | translate"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content class="content">
        <ng-template [ngTemplateOutlet]="guarantor"></ng-template>
        <div actions class="navigationButtons">
          <button
            (click)="handleContinueButtonClick()"
            mat-flat-button
            color="primary"
          >
            {{ "global.continueButton" | translate }}
          </button>
          <button
            (click)="handleBackButtonClick()"
            mat-flat-button
            color="secondary"
          >
            {{ "global.backButton" | translate }}
          </button>
        </div>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <div left-content [formGroup]="form" class="content">
        <ng-template [ngTemplateOutlet]="guarantor"></ng-template>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #guarantor>
  <div [formGroup]="form">
    <div class="first-paragraph-container">
      {{ "guarantor.firstParagraph" | translate }}
    </div>
    <div class="checkbox-container">
      <app-checkbox
        [checkboxLabel]="'guarantor.checkboxLabel' | translate"
        [control]="selfGuarantor"
      ></app-checkbox>
    </div>
    <div *ngIf="market !== 'nl' && selfGuarantor.value" class="guarantor-info">
      <div>{{ basicInfoService.personNumber }}</div>
      <div>{{ personalInfoService.email }}</div>
    </div>
    <div *ngIf="market !== 'nl'" class="add-additional-guarantor-container">
      <div
        formArrayName="additionalGuarantors"
        *ngFor="let item of additionalGuarantors['controls']; let i = index"
        class="additional-guarantor"
      >
        <div *ngIf="getAdditionalGuarantorFilled(i).value; else showForm">
          <div class="guarantor-info">
            <div>{{ getAdditionalGuarantorPersonNumberControl(i).value }}</div>
            <div>{{ getAdditionalGuarantorEmailControl(i).value }}</div>
          </div>
        </div>
        <ng-template #showForm>
          <div class="additional-guarantor-form">
            <div class="additional-guarantor-email-container">
              <app-input
                [label]="'guarantor.email'"
                [control]="getAdditionalGuarantorEmailControl(i)"
                [inputMode]="'email'"
                [error]="
                  getAdditionalGuarantorErrors(
                    'email',
                    getAdditionalGuarantorEmailControl(i)
                  )
                "
                [icon]="'email'"
              ></app-input>
            </div>
            <div class="additional-guarantor-person-number-container">
              <app-input
                [label]="'guarantor.personNumber'"
                [control]="getAdditionalGuarantorPersonNumberControl(i)"
                [inputMode]="'numeric'"
                [error]="
                  getAdditionalGuarantorErrors(
                    'personNumber',
                    getAdditionalGuarantorPersonNumberControl(i)
                  )
                "
                [icon]="'person'"
              ></app-input>
            </div>
            <button
              mat-flat-button
              color="primary"
              [disabled]="!additionalGuarantors['controls'][i].valid"
              (click)="addAdditionalGuarantorToApplication(i)"
            >
              {{ "guarantor.addAdditionalGuarantorSave" | translate }}
            </button>
            <button
              mat-icon-button
              disableRipple
              (click)="removeAdditionalGuarantor(i)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </ng-template>
      </div>
      <div
        (click)="addAdditionalGuarantorToForm()"
        class="additional-guarantor-label-container"
        *ngIf="!maxGuarantorsReached"
      >
        {{ "guarantor.addAdditionalGuarantorLabel" | translate }}
      </div>
    </div>
    <div class="infobox-container">
      <app-infobox
        [title]="'guarantor.infobox.title' | translate"
        [content]="'guarantor.infobox.content' | translate"
      >
      </app-infobox>
    </div>
    <div *ngIf="error" class="error">
      {{ error }}
    </div>
  </div>
</ng-template>
